// import logo from './logo.svg';
import "./App.css";
import { createBrowserRouter, RouterProvider, useSearchParams, Navigate } from "react-router-dom";
import { createContext, useEffect, useState, lazy, Suspense } from "react";
import activityLogSubmission from "./helper/activitylog";
import ReactGA from "react-ga4";

import HomePageV3 from "./pages/HomePageV3/HomePageV3";
import OpeningLoader from "./components/OpeningLoader/OpeningLoader";
import { fakeRules } from "./assets/fakeData";
import { handlePushNotification } from "./helper/notificationHandler";
import DevToolsProtector from "./DevToolsChecker/DevToolsProtector";
import { Helmet } from "react-helmet-async";

const QuizPage = lazy(() => import("./pages/QuizPage/QuizPage"));

// Lazy load campaign pages and other non-critical components
const Campaign = lazy(() => import("./pages/Campaign/Campaign"));
const Campaign2 = lazy(() => import("./pages/Campaign2/Campaign2"));
const Campaign3 = lazy(() => import("./pages/campaign3/Campaign3"));
const Campaign4 = lazy(() => import("./pages/campaign4/Campaign4"));
const Campaign5 = lazy(() => import("./pages/campaign5/Campaign5"));
const Campaign6 = lazy(() => import("./pages/campaign6/Campaign6"));
export const baseUrl = process.env.REACT_APP_BASE_URL || `https://cms.quizard.live`;
export const portal = 21;
export const categoryEventId = [42, 43, 44, 46, 76, 96, 97];


export const dataContext = createContext();


const router = createBrowserRouter([
  {
    path: "/rolling",
    element: <HomePageV3 />,
  },
  {
    path: "/",
    element: <HomePageV3 />,
  },
  {
    path: "/campaign/",
    element: <Suspense fallback={<OpeningLoader />}><Campaign /></Suspense>,
  },
  {
    path: "/campaign2/",
    element: <Suspense fallback={<OpeningLoader />}><Campaign2 /></Suspense>,
  },
  {
    path: "/campaign3/",
    element: <Suspense fallback={<OpeningLoader />}><Campaign3 subscriptionType="Tournament" campaignPageNumber="3" bannerImgSrc="/banners/campaign/camp3.png?v=1.1" /></Suspense>,
  },
  {
    path: "/campaign4/",
    // element: <Campaign4 />,
    element: <Suspense fallback={<OpeningLoader />}><Campaign3 subscriptionType="Sports" campaignPageNumber="4" bannerImgSrc="https://ms.quizard.live/bkash-quiz-banner/camp-banner/new_camp4.jpg" /></Suspense>,
  },
  {
    path: "/campaign5/",
    element: <Suspense fallback={<OpeningLoader />}><Campaign5 /></Suspense>,
  },
  {
    path: "/campaign6/",
    // element: <Campaign6 />,
    element: <Suspense fallback={<OpeningLoader />}><Campaign3 subscriptionType="BCS" campaignPageNumber="6" bannerImgSrc="https://ms.quizard.live/bkash-quiz-banner/camp-banner/new_camp6.jpg" /></Suspense>,
  },
  {
    path: "/campaign7/",
    element: <Suspense fallback={<OpeningLoader />}><Campaign3 subscriptionType="Daily" campaignPageNumber="7" bannerImgSrc="/banners/campaign/camp7.jpg" /></Suspense>,
  },
  {
    path: "/quiz/",
    element: <Suspense fallback={<OpeningLoader />}><QuizPage /></Suspense>,
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
]);
function App() {
  const url = new URL(window.location.href);
  let urlTokenParam = url.searchParams.get("auth_token_url");
  url.searchParams.delete('auth_token_url');
  let devMode = url.searchParams.get("devMode");
  if (devMode) { localStorage.setItem('devMode', devMode) }
  let referCode = url.searchParams.get("refer_code");
  if (referCode) { sessionStorage.setItem('refer_code', referCode) }
  let promoCode = url.searchParams.get("promo_code");
  if (promoCode) { sessionStorage.setItem('promo_code', promoCode) }
  window.history.pushState({}, '', url.href);
  let localToken = localStorage.getItem("AuthToken") || urlTokenParam || "";

  const [token, setToken] = useState(localToken);
  const [playerData, setPlayerData] = useState({});
  const [events, setEvents] = useState([]);
  const [openingLoader, setOpeningLoader] = useState(false);
  const [extraData, setExtraData] = useState([]);
  const [activeLeaderboardName, setActiveLeaderboardName] = useState('leaderboard_daily');
  useEffect(() => {
    setEvents(fakeRules)
    document.addEventListener('contextmenu', (e) => {
      e.preventDefault();
    });
    document.addEventListener('keydown', event => {
      if ((event.ctrlKey || event.metaKey) && (event.shiftKey) && (event.key === 'I' || event.key === 'J') || event.keyCode === 123) {
        event.preventDefault();
      }
    });
    activityLogSubmission("landing", localStorage.getItem('user_msisdn') || null);
    if (sessionStorage.getItem('initial_load') != 1) {
      sessionStorage.setItem('initial_load', 1);
      // pushCleverTapEvent("Unique Home View");
    }
  }, []);

  ReactGA.initialize([
    // {
    //   trackingId: "G-CRSTC3TC4D",
    // },
    {
      trackingId: "G-4PB7ZL0RMXA",
    },
  ]);

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Quizard Live",
    "alternateName": "কুইজার্ড",
    "url": "https://quizard.live",
    "description": "Play free online quiz games. কুইজ খেলুন, জ্ঞান পরীক্ষা করুন Quizard Live এ।",
    "inLanguage": ["en", "bn"]
  };

  const gameSchema = {
    "@context": "https://schema.org",
    "@type": "Game",
    "name": "Quizard Online Quiz",
    "url": "https://quizard.live",
    "genre": "Quiz Game",
    "description": "Free online quiz platform in English and Bangla. অনলাইন কুইজ খেলুন এবং জ্ঞান বাড়ান।"
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Quizard কি ফ্রি কুইজ?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "হ্যাঁ, Quizard Live একটি ফ্রি এবং প্রিমিয়াম উভয় ফিচার সম্পন্ন অনলাইন কুইজ প্ল্যাটফর্ম।"
        }
      },
      {
        "@type": "Question",
        "name": "Is Quizard Live free to play?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, you can play quizzes online for free and also there are premium features."
        }
      }
    ]
  };
  return (
    <>
      <Helmet>

        {/* BASIC SEO */}
        <title>Quizard | Online Quiz Game | কুইজার্ড অনলাইন কুইজ</title>

        <meta
          name="description"
          content="Play online quiz games on Quizard. কুইজ খেলুন, ট্রিভিয়া গেম খেলুন এবং আপনার জ্ঞান পরীক্ষা করুন কুইজার্ড-এ"
        />

        <meta
          name="keywords"
          content="quizard, quizard live, online quiz, quiz game bangladesh, trivia game, free quiz online, কুইজ, কুইজার্ড, অনলাইন কুইজ, ফ্রি কুইজ গেম, বাংলাদেশ কুইজ"
        />

        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://quizard.live/" />

        {/* OPEN GRAPH (Facebook / Messenger) */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Quizard | Online Quiz Game" />
        <meta property="og:description" content="Play quizzes online. কুইজ খেলুন Quizard Live এ।" />
        <meta property="og:url" content="https://quizard.live/" />
        <meta property="og:site_name" content="Quizard Live" />
        <meta property="og:image" content="https://quizard.live/logo512.png" />

        {/* TWITTER SEO */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Quizard Live Quiz Game" />
        <meta name="twitter:description" content="Play online quizzes" />
        <meta name="twitter:image" content="https://quizard.live/logo512.png" />

        {/* LANGUAGE */}
        <html lang="bn" />

        {/* STRUCTURED DATA FOR AEO */}
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>

        <script type="application/ld+json">
          {JSON.stringify(gameSchema)}
        </script>

        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>

      </Helmet>
      <DevToolsProtector>
        <div className="App">
          <div className="ppm_quiz_body">
            {openingLoader && <OpeningLoader />}
            <dataContext.Provider
              value={{
                token,
                setToken,
                playerData,
                setPlayerData,
                events,
                setEvents,
                portal,
                setOpeningLoader,
                extraData, setExtraData,
                activeLeaderboardName, setActiveLeaderboardName
              }}
            >
              <RouterProvider router={router} />
            </dataContext.Provider>
          </div>
        </div>
      </DevToolsProtector>
    </>
  );
}

export default App;
